import styled from "styled-components";

const ItalicEl = styled.i`
  font-style: italic;
`;

const Italic = ({ children }) => <ItalicEl>{children}</ItalicEl>;

export default Italic;
